// cd-utils.js — theme.liquid inline scriptlerinden tasindi (2026-08-20, ADIM 3)
// Bolum 1: cm -> ft donusturucu (US/CA). Ulke kodu theme.liquid inline window.cdCountry ile gelir.
// Bolum 2: sepet ozel-olcu injector (carpetdocia-cart-injector) — birebir kopya.
(function() {
    // AYARLAR
    const CONFIG = {
      targetSelector: '#MainContent', // Sadece ana içerik alanında çalışır (Header/Footer hariç)
      // Regex: "100x200" veya "100 x 200" desenini yakalar.
      regex: /\b(\d{2,3})\s*x\s*(\d{2,3})(?!\s*cm)\b/g 
    };

    // Fonksiyon: Metni ft'ye çevirir
    function convertText(text) {
      return text.replace(CONFIG.regex, (match, w, h) => {
        const widthCm = parseInt(w);
        const heightCm = parseInt(h);
        const widthFt = Math.round(widthCm * 0.0328084);
        const heightFt = Math.round(heightCm * 0.0328084);
        return `${widthFt}' x ${heightFt}' ft / ${widthCm} x ${heightCm} cm`;
      });
    }

    // Fonksiyon: HTML elementlerini tarar ve değiştirir
    function processNode(node) {
      // Eğer bir yazı düğümü ise ve içinde desenimiz varsa
      if (node.nodeType === 3 && node.nodeValue.match(CONFIG.regex)) {
        if (node.nodeValue.trim() !== "") {
           node.nodeValue = convertText(node.nodeValue);
        }
      } 
      // Eğer bir element ise (div, p, span vb.) içine gir
      else if (node.nodeType === 1) {
        // Script ve Style etiketlerini atla
        if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
        node.childNodes.forEach(child => processNode(child));
      }
    }

    // Başlatıcı
    function init() {
      // Shopify'dan ülke kodunu al
      const userCountry = window.cdCountry || "";
      
      // TEST MODU: Türkiye'den test etmek için alttaki satırın başındaki // işaretlerini kaldır.
      // const userCountry = "US"; 

      // Sadece US ve CA ise devam et
      if (userCountry !== 'US' && userCountry !== 'CA') return;

      const contentArea = document.querySelector(CONFIG.targetSelector);
      if (!contentArea) return;

      const contentArea2 = contentArea;

      // 1. Mevcut sayfayı hemen dönüştür
      processNode(contentArea);

      // 2. Gelecekteki değişiklikleri (Filtreleme, Load More) izle
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((addedNode) => {
            processNode(addedNode);
          });
        });
      });

      observer.observe(contentArea, {
        childList: true,
        subtree: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

(function() {
  'use strict';
  if (window.__cdCartInjectorActive) return;
  window.__cdCartInjectorActive = true;

  var DEBUG = false;
  var CACHE_TTL = 1500;
  var cartCache = null;
  var cartCacheAt = 0;
  var procTimer = null;

  function log() {
    if (!DEBUG) return;
    var a = ['[CD-CART]'].concat([].slice.call(arguments));
    try { console.log.apply(console, a); } catch(e) {}
  }

  function fetchCart() {
    var now = Date.now();
    if (cartCache && (now - cartCacheAt) < CACHE_TTL) {
      return Promise.resolve(cartCache);
    }
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function(r) { return r && r.ok ? r.json() : null; })
      .then(function(d) { cartCache = d; cartCacheAt = Date.now(); return d; })
      .catch(function(e) { log('cart fetch fail', e); return null; });
  }

  function findItemEls() {
    var sels = ['.ajaxcart__product', '.cart-drawer__item', '[data-line-item]', '.cart__item', '[data-cart-item]'];
    for (var i = 0; i < sels.length; i++) {
      var els = document.querySelectorAll(sels[i]);
      if (els.length) return [].slice.call(els);
    }
    return [];
  }

  function findIn(el, sels) {
    for (var i = 0; i < sels.length; i++) {
      var f = el.querySelector(sels[i]);
      if (f) return f;
    }
    return null;
  }

  function fmtPrice(cents) {
    var tl = Math.round((cents || 0) / 100);
    return tl.toLocaleString('tr-TR') + ' TL';
  }

  function getKey(el) {
    return el.getAttribute('data-line-item-key') ||
           el.getAttribute('data-key') ||
           el.getAttribute('data-id') ||
           (el.dataset && el.dataset.key) || null;
  }

  function findTitleEl(el) {
    var cands = [
      '.ajaxcart__product-name', '.cart__product-title', '.cart-item__title',
      '.cart__product-name', '.cart-product__name', '.line-item__title',
      '.ajaxcart__product-title', '[class*="product-name"]',
      '[class*="product-title"]', '[class*="item-title"]'
    ];
    for (var i = 0; i < cands.length; i++) {
      var f = el.querySelector(cands[i]);
      if (f && f.textContent.trim()) { log('title via', cands[i]); return f; }
    }
    var link = el.querySelector('a[href*="/products/"]');
    if (link && link.textContent.trim()) { log('title via product link'); return link; }
    var heading = el.querySelector('h2, h3, h4, h5');
    if (heading && heading.textContent.trim()) { log('title via heading'); return heading; }
    log('title NOT FOUND');
    return null;
  }

  function findQtyContainer(el) {
    var cands = [
      '.ajaxcart__qty', '.cart__qty', '.cart-item__qty',
      '.cart__qty-wrapper', '.cart__quantity', '.js-qty', '.quantity-selector',
      '[class*="qty-wrapper"]', '[class*="quantity-wrapper"]'
    ];
    for (var i = 0; i < cands.length; i++) {
      var f = el.querySelector(cands[i]);
      if (f) { log('qty via', cands[i]); return f; }
    }
    var inputs = el.querySelectorAll('input');
    for (var j = 0; j < inputs.length; j++) {
      var input = inputs[j];
      var name = (input.getAttribute('name') || '').toLowerCase();
      var cls = (input.className || '').toLowerCase();
      var isQty = name.indexOf('quantity') >= 0 || name.indexOf('updates') >= 0 ||
                  cls.indexOf('qty') >= 0 || cls.indexOf('quantity') >= 0 ||
                  input.type === 'number';
      if (!isQty) continue;
      var parent = input.parentElement;
      var depth = 0;
      while (parent && parent !== el && depth < 5) {
        var btns = parent.querySelectorAll('button, a');
        var hasPlus = false, hasMinus = false;
        for (var k = 0; k < btns.length; k++) {
          var t = btns[k].textContent.trim();
          if (t === '+') hasPlus = true;
          if (t === '−' || t === '-' || t === '–') hasMinus = true;
        }
        if (hasPlus && hasMinus) { log('qty via input+buttons walk'); return parent; }
        parent = parent.parentElement;
        depth++;
      }
      return input.parentElement;
    }
    log('qty NOT FOUND');
    return null;
  }

  // === Buton tanıma — class, aria, data, text fallback'leriyle ===
  function identifyQtyButton(btn) {
    if (!btn) return null;
    var text = (btn.textContent || '').trim();
    var cls = (btn.className || '').toString().toLowerCase();
    var aria = (btn.getAttribute('aria-label') || '').toLowerCase();
    var dataAdjust = (btn.getAttribute('data-qty-adjust') ||
                     btn.getAttribute('data-action') ||
                     btn.getAttribute('data-direction') || '').toLowerCase();

    // Class-based (en güvenilir)
    if (cls.indexOf('--minus') >= 0 || cls.indexOf('--decrease') >= 0 ||
        cls.indexOf('-down') >= 0 || cls.indexOf('decrement') >= 0 ||
        cls.indexOf('qty-minus') >= 0) return 'minus';
    if (cls.indexOf('--plus') >= 0 || cls.indexOf('--increase') >= 0 ||
        cls.indexOf('-up') >= 0 || cls.indexOf('increment') >= 0 ||
        cls.indexOf('qty-plus') >= 0) return 'plus';

    // Data attribute
    if (dataAdjust === '-' || dataAdjust === 'minus' || dataAdjust === 'decrease' || dataAdjust === 'down') return 'minus';
    if (dataAdjust === '+' || dataAdjust === 'plus' || dataAdjust === 'increase' || dataAdjust === 'up') return 'plus';

    // Aria label (TR + EN)
    if (aria.indexOf('reduce') >= 0 || aria.indexOf('decrease') >= 0 ||
        aria.indexOf('azalt') >= 0 || aria.indexOf('düşür') >= 0) return 'minus';
    if (aria.indexOf('increase') >= 0 || aria.indexOf('artır') >= 0 ||
        aria.indexOf('yükselt') >= 0) return 'plus';

    // Text-based — sadece minus/plus karakteri olan
    if (/^[\s]*[-−–][\s]*$/.test(text)) return 'minus';
    if (/^[\s]*\+[\s]*$/.test(text)) return 'plus';

    // Son çare: text içeriği uzun değilse symbol var mı bak
    if (text.length < 30) {
      if (/\+/.test(text) && !/[-−–]/.test(text)) return 'plus';
      if (/[-−–]/.test(text) && !/\+/.test(text)) return 'minus';
    }

    return null;
  }

  function replaceImage(el, url) {
    if (!url) return;
    try {
      var img = findIn(el, [
        '.ajaxcart__product-image img', '.cart-item__image img',
        '.cart__image img', 'img'
      ]);
      if (!img) return;
      if (!img.dataset.cdOrigSrc) img.dataset.cdOrigSrc = img.src || '';
      if (img.srcset && !img.dataset.cdOrigSrcset) img.dataset.cdOrigSrcset = img.srcset;
      img.src = url;
      img.srcset = '';
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    } catch(e) { log('img fail', e); }
  }

  function fixLinks(el, productUrl) {
    if (!productUrl) return;
    try {
      var links = el.querySelectorAll('a');
      [].forEach.call(links, function(a) {
        var href = a.getAttribute('href') || '';
        if (href.indexOf('/products/') >= 0) {
          if (!a.dataset.cdOrigHref) a.dataset.cdOrigHref = href;
          a.setAttribute('href', productUrl);
        }
      });
    } catch(e) { log('link fix fail', e); }
  }

  function replaceTitle(el, newTitle) {
    if (!newTitle) return false;
    try {
      var t = findTitleEl(el);
      if (!t) return false;
      if (!t.dataset.cdOrigTitle) t.dataset.cdOrigTitle = t.textContent;

      for (var i = 0; i < t.childNodes.length; i++) {
        var n = t.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) {
          n.textContent = newTitle;
          log('title replaced (direct)');
          return true;
        }
      }
      var stack = [].slice.call(t.children);
      while (stack.length) {
        var child = stack.shift();
        var cls = (child.className || '').toString().toLowerCase();
        if (cls.indexOf('property') >= 0 || cls.indexOf('option') >= 0 ||
            cls.indexOf('meta') >= 0 || cls.indexOf('properties') >= 0) {
          continue;
        }
        for (var j = 0; j < child.childNodes.length; j++) {
          var n2 = child.childNodes[j];
          if (n2.nodeType === 3 && n2.textContent.trim()) {
            n2.textContent = newTitle;
            log('title replaced (descendant)');
            return true;
          }
        }
        for (var k = 0; k < child.children.length; k++) {
          stack.push(child.children[k]);
        }
      }
      log('title preserved');
      return false;
    } catch(e) { log('title fail', e); return false; }
  }

  function hideSecilenUrunLine(el) {
    try {
      var allEls = el.querySelectorAll('li, p, div, span, dt, dd, tr');
      [].forEach.call(allEls, function(node) {
        if (node.dataset.cdHiddenSecilen) return;
        var text = (node.textContent || '').trim();
        if (text.indexOf('Seçilen Ürün') === 0 && text.length < 500) {
          var target = null;
          var current = node;
          var depth = 0;
          while (current && current !== el && depth < 5) {
            var tag = (current.tagName || '').toLowerCase();
            var cls = (current.className || '').toString().toLowerCase();
            if (tag === 'li' || tag === 'tr') { target = current; break; }
            if (cls.indexOf('property') >= 0 || cls.indexOf('option') >= 0 ||
                cls.indexOf('meta-row') >= 0 || cls.indexOf('line-item-property') >= 0) {
              target = current; break;
            }
            current = current.parentNode;
            depth++;
          }
          if (!target) target = node;
          if (target && !target.dataset.cdHiddenSecilen) {
            target.dataset.cdHiddenSecilen = '1';
            target.style.display = 'none';
          }
        }
      });
    } catch(e) { log('hide secilen urun fail', e); }
  }

  // Real qty container'ı CSS class ile gizle (inline style YOK).
  function hideRealQty(el) {
    try {
      var q = findQtyContainer(el);
      if (q && !q.classList.contains('cd-real-qty-hidden')) {
        q.classList.add('cd-real-qty-hidden');
      }
      return q;
    } catch(e) { log('hide qty fail', e); return null; }
  }

  function stripIdAndDataAttrs(node) {
    if (!node) return;
    if (node.removeAttribute) {
      node.removeAttribute('id');
      if (node.attributes) {
        for (var i = node.attributes.length - 1; i >= 0; i--) {
          var name = node.attributes[i].name;
          if (name.indexOf('data-') === 0) node.removeAttribute(name);
        }
      }
    }
    if (node.children) {
      for (var j = 0; j < node.children.length; j++) {
        stripIdAndDataAttrs(node.children[j]);
      }
    }
  }

  // === FAKE QTY — clone + DOĞRUDAN buton click handler (overlay YOK) ===
  // Capture-phase click handler ile tema'nın delegated handler'ı tetiklenmeden
  // önce iptal ediyoruz. Rect ölçümü ve overlay timing sorunu yok.
  function injectFakeQty(el, qContainer, lineKey, lineItemEl) {
    try {
      if (el.querySelector('.cd-fake-qty')) return;
      if (!qContainer) qContainer = el.querySelector('.cd-real-qty-hidden') || findQtyContainer(el);
      if (!qContainer || !qContainer.parentNode) return;

      // 1) Klonla (görsel birebir korunur)
      var temp = document.createElement('div');
      temp.innerHTML = qContainer.outerHTML;
      var fake = temp.firstElementChild;
      if (!fake) return;

      fake.classList.add('cd-fake-qty');
      fake.classList.remove('cd-real-qty-hidden');
      fake.style.display = '';

      // 2) Buton tanıma — strip etmeden ÖNCE
      var minusBtn = null, plusBtn = null;
      [].forEach.call(fake.querySelectorAll('button, a'), function(btn) {
        var role = identifyQtyButton(btn);
        if (role === 'minus' && !minusBtn) minusBtn = btn;
        else if (role === 'plus' && !plusBtn) plusBtn = btn;
      });

      // 3) Strip id ve data-* (delegation hijyen)
      stripIdAndDataAttrs(fake);

      // 4) Input'u 1 yap, readonly, name'i sil
      var inputs = fake.querySelectorAll('input');
      [].forEach.call(inputs, function(inp) {
        inp.value = '1';
        inp.setAttribute('readonly', 'readonly');
        inp.tabIndex = -1;
        inp.removeAttribute('name');
        inp.style.pointerEvents = 'none';
      });

      // 5) Linkleri href'siz hale getir (nav tetiklemesin)
      [].forEach.call(fake.querySelectorAll('a'), function(a) {
        a.removeAttribute('href');
        a.removeAttribute('onclick');
      });

      // 6) Fake'i konumla
      fake.style.position = 'relative';

      // 7) DOM'a ekle
      qContainer.parentNode.insertBefore(fake, qContainer.nextSibling);

      // 8) BUTONLARA DOĞRUDAN CAPTURE-PHASE CLICK HANDLER
      //    — overlay yok, rect ölçümü yok, timing sorunu yok
      if (minusBtn) {
        minusBtn.style.cursor = 'pointer';
        minusBtn.title = 'Sepetten kaldır';
        minusBtn.setAttribute('aria-label', 'Sepetten kaldır');
        minusBtn.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          if (minusBtn.dataset.cdRemoving) return;
          minusBtn.dataset.cdRemoving = '1';
          minusBtn.style.opacity = '0.5';
          minusBtn.style.cursor = 'wait';
          removeLineInPlace(lineKey, lineItemEl);
        }, true); // CAPTURE phase — tema'nın bubble delegation'ı tetiklenmeden ÖNCE çalışır
      }

      if (plusBtn) {
        plusBtn.style.opacity = '0.3';
        plusBtn.style.cursor = 'not-allowed';
        plusBtn.title = 'Aynı boyuttan eklemek için ürün sayfasına dönün';
        plusBtn.setAttribute('aria-label', 'Devre dışı');
        plusBtn.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          return false;
        }, true);
      }

    } catch(e) { log('fake qty fail', e); }
  }

  // === SİLME — Native remove link ile temaya delege et (1.5s watchdog ile) ===
  // Strateji A (PRİMARY): Native remove link click. Impulse'un .ajaxcart__remove'u
  //   bu işlem için tasarlanmış, doğru AJAX akışını ve drawer rebuild'i çağırır.
  // Strateji B (fallback): Real input → 0 dispatch.
  // Strateji C (last resort): Direkt /cart/change.js + cart event'leri.
  // Watchdog: her stratejiden sonra 1.5s bekle, line hâlâ DOM'da ise sıradakine geç.
  function removeLineInPlace(lineKey, lineItemEl) {
    if (!lineItemEl) { log('no line item el'); return; }

    function stillInDom() {
      return lineItemEl.parentNode && document.contains(lineItemEl);
    }

    function strategyC() {
      if (!lineKey) { log('no line key, give up'); return; }
      log('strategy C: direct /cart/change.js');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
        credentials: 'same-origin'
      })
      .then(function(r) { return r && r.ok ? r.json() : null; })
      .then(function(cart) {
        if (!cart) return;
        cartCache = null; cartCacheAt = 0;
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { detail: cart }));
          if (cart.item_count === 0) {
            document.dispatchEvent(new CustomEvent('cart:empty'));
          }
        } catch(e) {}
      })
      .catch(function(e) { log('remove fail', e); });
    }

    function strategyB() {
      var realQty = lineItemEl.querySelector('.cd-real-qty-hidden') || findQtyContainer(lineItemEl);
      if (realQty) {
        var realInput = realQty.querySelector('input[type="number"], input[name*="quantity"], input[name*="updates"], input[type="text"]');
        if (realInput) {
          log('strategy B: real qty input → 0');
          try {
            var proto = window.HTMLInputElement && window.HTMLInputElement.prototype;
            var desc = proto && Object.getOwnPropertyDescriptor(proto, 'value');
            if (desc && desc.set) desc.set.call(realInput, '0');
            else realInput.value = '0';
            ['input', 'change', 'blur', 'keyup'].forEach(function(ev) {
              try { realInput.dispatchEvent(new Event(ev, { bubbles: true, cancelable: true })); } catch(e) {}
            });
            setTimeout(function() {
              if (stillInDom()) { log('B watchdog: still in DOM, fallback C'); strategyC(); }
            }, 1500);
            return;
          } catch(e) { log('B fail', e); }
        }
      }
      strategyC();
    }

    // STRATEJİ A — Native remove link (Impulse'ta `.ajaxcart__remove` kesin var)
    var removeSels = [
      '.ajaxcart__remove', '.cart__remove', '.cart-item__remove',
      '[data-cart-remove]', '[data-action="remove"]',
      'a[href*="quantity=0"]', 'button[name="remove"]',
      '[class*="remove-from-cart"]', '[class*="cart-remove"]'
    ];
    for (var i = 0; i < removeSels.length; i++) {
      var rm = lineItemEl.querySelector(removeSels[i]);
      if (rm) {
        log('strategy A: native remove via', removeSels[i]);
        try { rm.click(); } catch(e) { log('A click fail', e); }
        setTimeout(function() {
          if (stillInDom()) { log('A watchdog: still in DOM, fallback B'); strategyB(); }
        }, 1500);
        return;
      }
    }

    log('A: no native remove found, going to B');
    strategyB();
  }

  // === ÖNCEKİ YANLIŞ STRATEJİDEN KALAN KİRLİLİĞİ TEMİZLE ===
  function cleanupPriorPollution() {
    try {
      var hiddenFooters = document.querySelectorAll('[data-cd-hidden-footer]');
      [].forEach.call(hiddenFooters, function(el) {
        el.style.display = '';
        el.removeAttribute('data-cd-hidden-footer');
      });
      var hiddenCheckouts = document.querySelectorAll('[data-cd-hidden-checkout]');
      [].forEach.call(hiddenCheckouts, function(el) {
        el.style.display = '';
        el.removeAttribute('data-cd-hidden-checkout');
      });
      var emptyMsgs = document.querySelectorAll('.cd-empty-msg');
      [].forEach.call(emptyMsgs, function(el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    } catch(e) { log('cleanup fail', e); }
  }

  function replacePrice(el, totalCents) {
    try {
      var prices = el.querySelectorAll('.ajaxcart__price, .cart__price, .cart-item__price, .ajaxcart__discount-price, [class*="line-price"], [class*="item-price"]');
      [].forEach.call(prices, function(p) {
        if (!p.dataset.cdOrigPrice) p.dataset.cdOrigPrice = p.innerHTML;
        p.textContent = fmtPrice(totalCents);
      });
    } catch(e) { log('price fail', e); }
  }

  function processItem(el, line) {
    if (!el || !line) return;
    var props = line.properties || {};
    if (props._OzelOlcu !== 'Evet') {
      el.setAttribute('data-cd-processed', 'normal');
      return;
    }
    if (el.getAttribute('data-cd-processed') === 'custom') return;

    var realTitle = props['Seçilen Ürün'] || line.product_title;
    var imgUrl = props._productImgUrl || '';
    var productUrl = props._productUrl || '';
    var totalCents = line.final_line_price || line.line_price || 0;

    replaceImage(el, imgUrl);
    fixLinks(el, productUrl);
    var titleReplaced = replaceTitle(el, realTitle);
    if (titleReplaced) {
      hideSecilenUrunLine(el);
    }
    var qContainer = hideRealQty(el);
    injectFakeQty(el, qContainer, line.key, el);
    replacePrice(el, totalCents);

    el.setAttribute('data-cd-processed', 'custom');
    log('injected', line.key, realTitle);
  }

  function processCart() {
    var els = findItemEls();
    if (!els.length) return;
    fetchCart().then(function(cart) {
      if (!cart || !cart.items) return;
      els.forEach(function(el, idx) {
        var key = getKey(el);
        var match = null;
        if (key) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === key || String(cart.items[i].id) === key) {
              match = cart.items[i]; break;
            }
          }
        }
        if (!match) match = cart.items[idx];
        if (!match) return;
        processItem(el, match);
      });
    });
  }

  function schedule() {
    if (procTimer) clearTimeout(procTimer);
    procTimer = setTimeout(function() {
      cartCache = null; cartCacheAt = 0;
      processCart();
    }, 120);
  }

  function init() {
    cleanupPriorPollution();

    var target = document.getElementById('CartDrawer') ||
                 document.querySelector('.cart-drawer') ||
                 document.getElementById('cart') ||
                 document.body;
    try {
      new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
    } catch(e) { log('observer fail', e); }

    ['ajaxProduct:added', 'cart:updated', 'cart:refresh', 'cart:open',
     'ajaxCart.afterCartLoad', 'shopify:section:load'].forEach(function(ev) {
      document.addEventListener(ev, schedule);
    });

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
